<template>
  <div class="error-404 text-center">
    <div class="row">
      <div class="col-md-12">
        <alert-triangle-icon size="150" class="mb-4"/>
        <h1>Ops... Página não encontrada!</h1>
        <hr>
      </div>
      <div class="col-md-12">
        <button @click="$router.back()" type="button" class="btn btn-primary btn-xl" data-dismiss="modal">Clique aqui para voltar</button>
      </div>
    </div>
  </div>

</template>

<script>
import { AlertTriangleIcon } from 'vue-feather-icons'

  export default {
    components: { AlertTriangleIcon },
    name: 'NotFound'
  }
</script>

<style scoped>

.error-404{
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
}

</style>
